import { z } from "zod";
export const DTODocumentationAnalyticsTimeFrame = z.object({
    start: z.coerce.date(),
    end: z.coerce.date().optional(),
});
//
// Read
//
export const DTOPublishedDocVisitData = z.object({
    timestamp: z.coerce.date(),
    versionId: z.string(),
    locale: z.string().optional(),
    visits: z.number(),
    sessions: z.number(),
});
export const DTOPublishedDocPageVisitData = DTOPublishedDocVisitData.extend({
    pagePersistentId: z.string(),
});
/**
 * Array of values per 2 hours (0, 2, 4, 6, etc)
 */
const DTOPublishedDocVisitHeatMapDay = z.number().array().length(12);
export const DTOPublishedDocVisitHeatMapWeek = z.object({
    /**
     * For which timeframe it was calculated
     */
    timeFrame: DTODocumentationAnalyticsTimeFrame,
    mon: DTOPublishedDocVisitHeatMapDay,
    tue: DTOPublishedDocVisitHeatMapDay,
    wed: DTOPublishedDocVisitHeatMapDay,
    thu: DTOPublishedDocVisitHeatMapDay,
    fri: DTOPublishedDocVisitHeatMapDay,
    sat: DTOPublishedDocVisitHeatMapDay,
    sun: DTOPublishedDocVisitHeatMapDay,
});
export const DTOPublishedDocAnalyticsComparisonData = z.object({
    /**
     * For which timeframe it was calculated
     */
    timeFrame: DTODocumentationAnalyticsTimeFrame,
    priorVisitCount: z.number(),
    priorSessionCount: z.number(),
    currentVisitCount: z.number(),
    currentSessionCount: z.number(),
});
export const DTOPublishedDocPageAnalyticsComparisonData = DTOPublishedDocAnalyticsComparisonData.extend({
    pagePersistentId: z.string(),
});
export const DTODocumentationPageAnalyticsResponse = z.object({
    globalAnalytics: DTOPublishedDocVisitData.array(),
    pageAnalytics: DTOPublishedDocPageVisitData.array(),
    heatMapData: DTOPublishedDocVisitHeatMapWeek.array(),
    comparisonData: DTOPublishedDocAnalyticsComparisonData.array(),
    pageComparisonData: DTOPublishedDocPageAnalyticsComparisonData.array(),
});
export const DTODocumentationAnalyticsRequest = z.object({
    timeFrames: z.array(DTODocumentationAnalyticsTimeFrame),
});
